export const addZeroInTime = (num: number) => {
  let result = num as number | string;
  if (num < 10) {
    result = '0' + num;
  }
  return result;
};
